import { useContext } from 'react';
import {
  DiscountActionContext,
  DiscountContext,
} from '../context/discountContext';

export const useDiscount = () => {
  const context = useContext(DiscountContext);

  if (!context)
    throw new Error('useAuth must be used within a AuthContextProvider');

  return context;
};

export const useDiscountActions = () => {
  const context = useContext(DiscountActionContext);

  if (!context)
    throw new Error(
      'useAuthActions must be used within a AuthActionsContextProvider',
    );

  return context;
};
